// PogojiUporabe.jsx
import React from "react";

export default function PogojiUporabe() {
  const effectiveDate = "03. 02. 2026"; // prilagodi po potrebi

  const sections = [
    {
      title: "1. Splošno",
      body: (
        <>
          <p>
            Ti Pogoji uporabe (v nadaljevanju: “Pogoji”) urejajo uporabo spletne
            strani <strong>e2f.si</strong> (v nadaljevanju: “Spletna stran”) in
            vseh povezanih storitev, ki jih nudi upravljavec spletne strani
            (v nadaljevanju: “Upravljavec”).
          </p>
          <p className="mt-3">
            Z uporabo Spletne strani potrjuješ, da si seznanjen/a s Pogoji in se
            z njimi strinjaš. Če se s Pogoji ne strinjaš, prosimo, da Spletne
            strani ne uporabljaš.
          </p>
        </>
      ),
    },
    {
      title: "2. Namen spletne strani in narava storitve",
      body: (
        <>
          <p>
            Spletna stran deluje kot <strong>iskalnik izdelkov in storitev</strong>
            ter omogoča uporabnikom iskanje in prikaz rezultatov (npr. kategorij,
            storitev ali izdelkov) ter prikaz povezanih <strong>ponudnikov</strong>.
          </p>
          <p className="mt-3">
            Spletna stran je informativne narave. Upravljavec praviloma ne
            nastopa kot ponudnik storitev ali prodajalec izdelkov, temveč kot
            posrednik informacij in povezav.
          </p>
        </>
      ),
    },
    {
      title: "3. Uporabniški račun in dostop",
      body: (
        <>
          <p>
            Spletna stran lahko uporablja mehanizem dostopa (npr. “gostujoči
            dostop”/token) za delovanje iskalnika in prikaz rezultatov. Uporabnik
            se zavezuje, da storitev ne bo zlorabljal (npr. avtomatizirano
            pošiljanje zahtevkov, napadi, obremenjevanje sistema).
          </p>
        </>
      ),
    },
    {
      title: "4. Rezultati iskanja in ponudniki",
      body: (
        <>
          <p>
            Rezultati iskanja in seznam ponudnikov se prikazujejo na podlagi
            podatkovnih virov in/ali vnosov, ki so lahko delno avtomatizirani.
            Upravljavec ne jamči, da bodo podatki vedno popolni, ažurni ali brez
            napak.
          </p>
          <p className="mt-3">
            Ponudniki (podjetja/obrtniki) so za pravilnost svojih informacij,
            ponudb, cenikov in pogojev odgovorni sami. Morebitne dogovore o
            storitvah ali nakupu uporabnik sklene neposredno s ponudnikom.
          </p>
        </>
      ),
    },
    {
      title: "5. Zunanji povezavi (linki) in odgovornost",
      body: (
        <>
          <p>
            Spletna stran lahko vsebuje povezave na zunanje spletne strani (npr.
            “Odpri” povezave do spletnih strani ponudnikov). Upravljavec ne
            upravlja teh strani in ne odgovarja za njihovo vsebino, varnost ali
            pravilnost informacij.
          </p>
          <p className="mt-3">
            Uporaba zunanjih povezav je na lastno odgovornost uporabnika.
          </p>
        </>
      ),
    },
    {
      title: "6. Pravice intelektualne lastnine",
      body: (
        <>
          <p>
            Vse vsebine na Spletni strani (besedila, grafike, dizajn, koda,
            baze podatkov ipd.) so zaščitene z avtorskimi pravicami in/ali
            drugimi pravicami intelektualne lastnine ter so last Upravljavca
            ali njegovih partnerjev/imetnikov pravic.
          </p>
          <p className="mt-3">
            <strong>
              Logotipi in blagovne znamke prikazani na strani so last njihovih
              zakonitih lastnikov
            </strong>{" "}
            in niso v lasti Upravljavca, razen če je izrecno navedeno drugače.
          </p>
        </>
      ),
    },
    {
      title: "7. Prepovedane uporabe",
      body: (
        <>
          <p>Uporabnik ne sme:</p>
          <ul className="list-disc ml-6 mt-2 space-y-2">
            <li>uporabljati storitve za nezakonite namene,</li>
            <li>poskušati nepooblaščenega dostopa do sistemov,</li>
            <li>
              izvajati scraping, masovno avtomatizirano pridobivanje podatkov ali
              obremenjevati API-ja brez pisnega dovoljenja,
            </li>
            <li>objavljati ali posredovati zlonamerne kode ali vsebin.</li>
          </ul>
        </>
      ),
    },
    {
      title: "8. Omejitev odgovornosti",
      body: (
        <>
          <p>
            Upravljavec ne odgovarja za neposredno ali posredno škodo, izgubo
            dobička, izgubo podatkov ali druge posledice, ki bi nastale zaradi:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-2">
            <li>uporabe ali nezmožnosti uporabe Spletne strani,</li>
            <li>napačnih ali neažurnih podatkov o ponudnikih,</li>
            <li>napak, prekinitev delovanja, virusov ali varnostnih incidentov,</li>
            <li>poslovnega odnosa med uporabnikom in ponudnikom.</li>
          </ul>
          <p className="mt-3">
            Upravljavec si prizadeva za pravilno delovanje, vendar ne jamči
            neprekinjene dostopnosti.
          </p>
        </>
      ),
    },
    {
      title: "9. Varstvo osebnih podatkov",
      body: (
        <>
          <p>
            Obdelava osebnih podatkov (če se izvaja, npr. preko kontaktnih obrazcev,
            e-pošte ipd.) je opisana v dokumentu{" "}
            <strong>Politika zasebnosti</strong>. Prosimo, preberi ga pred uporabo.
          </p>
          <p className="mt-3">
            Če Spletna stran uporablja piškotke ali podobne tehnologije, bo to
            opisano v Politiki zasebnosti in/ali obvestilu o piškotkih.
          </p>
        </>
      ),
    },
    {
      title: "10. Spremembe pogojev",
      body: (
        <>
          <p>
            Upravljavec si pridržuje pravico do spremembe Pogojev. Spremembe
            začnejo veljati z objavo na Spletni strani. Nadaljnja uporaba po
            objavi pomeni, da se s spremembami strinjaš.
          </p>
        </>
      ),
    },
    {
      title: "11. Veljavno pravo in reševanje sporov",
      body: (
        <>
          <p>
            Za Pogoje in uporabo Spletne strani velja pravo Republike Slovenije.
            Morebitne spore rešuje pristojno sodišče glede na sedež Upravljavca,
            razen če zakon določa drugače.
          </p>
        </>
      ),
    },
    {
      title: "12. Kontakt",
      body: (
        <>
          <p>
            Za vprašanja, pripombe ali uveljavljanje pravic nas kontaktiraj preko
            kontaktnih podatkov, objavljenih na Spletni strani (razdelek “Kontakt”).
          </p>
        </>
      ),
    },
  ];

  return (
    <div
      className="min-h-screen"
      style={{
        background: "linear-gradient(135deg, #005d7e, #022e59, #fafafa)",
      }}
    >
      {/* Header */}
      <header className="relative z-10">
        <div className="max-w-7xl mx-auto px-5 py-6 flex justify-center">
          <a href="/" className="inline-flex items-center">
            <img src="/e2fsilogo.png" alt="Logo" style={{ width: "160px" }} />
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="px-5 pb-24">
        <section className="max-w-5xl mx-auto pt-10 pb-16">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight">
              Pogoji uporabe
            </h1>
          </div>

          <div className="bg-white rounded-[40px] shadow-lg mt-12 p-8 md:p-12">
            <p className="text-gray-600 leading-relaxed">
              Ta dokument določa pravila uporabe spletne strani e2f.si in razmerje
              med uporabnikom in upravljavcem.
            </p>

            <div className="mt-10 space-y-10">
              {sections.map((s, idx) => (
                <div key={idx} className="border-b border-gray-100 pb-10">
                  <h2 className="text-2xl font-bold text-gray-800">
                    {s.title}
                  </h2>
                  <div className="mt-4 text-gray-700 leading-relaxed space-y-3">
                    {s.body}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-between items-center">
              <a
                href="/"
                className="bg-gray-900 text-white px-6 py-3 rounded-full font-semibold text-sm shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
              >
                Nazaj na začetno
              </a>

            </div>
          </div>
        </section>
      </main>

      {/* Footer mini */}
      <footer className="text-center text-sm text-gray-600 pb-10">
        © {new Date().getFullYear()} e2f.si. Vse pravice pridržane.
      </footer>
    </div>
  );
}
